module.exports = __webpack_public_path__ + "img/head_three.1edd84de.png";